var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.281 0H1.72A1.72 1.72 0 0 0 0 1.719v8.08a.688.688 0 0 0 1.375 0v-8.08c0-.19.154-.344.344-.344H20.28c.19 0 .344.154.344.344v13.983c0 .19-.154.344-.344.344H1.72a.344.344 0 0 1-.344-.344v-1.779h16.5a.688.688 0 0 0 0-1.375H.688a.69.69 0 0 0-.688.687v2.467a1.72 1.72 0 0 0 1.719 1.719h6.383l-1.137 2.504a.688.688 0 0 0 1.252.569l1.395-3.073h2.776l.955 2.101h-2.315a.687.687 0 1 0 0 1.375h3.382a.688.688 0 0 0 .626-.972l-1.137-2.504h6.382A1.72 1.72 0 0 0 22 15.702V1.719A1.72 1.72 0 0 0 20.281 0",
    fill: "#FF5956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.918 6.942a.687.687 0 1 0-1.028.913l.944 1.063a.7.7 0 0 0 .483.23l.032.001a.7.7 0 0 0 .47-.185l2.247-2.105a.688.688 0 0 0-.94-1.004l-1.732 1.622z",
    fill: "#FF5956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.852 2.296a.69.69 0 0 0-.688.687v.209H6.016a.69.69 0 0 0-.688.687v7.06c0 .38.308.688.688.688h9.968c.38 0 .688-.308.688-.687V3.88a.688.688 0 0 0-1.375 0v6.372H6.703V4.567h2.149c.38 0 .687-.308.687-.688v-.896a.69.69 0 0 0-.687-.687",
    fill: "#FF5956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.148 4.567c.38 0 .688-.308.688-.688v-.896a.688.688 0 0 0-1.375 0v.209h-.86a.688.688 0 0 0 0 1.375z",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatus);
export default __webpack_public_path__ + "static/media/ic_status.a3920dff8ffbf19c919aa5583ca1cd01.svg";
export { ForwardRef as ReactComponent };